module.exports = "\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/session/terminar/sessionterminar.component.css
// module id = ./src/app/session/terminar/sessionterminar.component.css
// module chunks = main